import { lazy } from 'react';

// Procurement (Procurement)
// V3 surface unifies orders + catalog + vendors into one PO-centric narrative
// (the V2 was carts-only and pointed at /procurement/carts). PO detail, hardware
// profiles and product catalog management stay as
// separate admin consoles linked from the V3 narrative.
// Cluster collapse 2026-04-28: ProcurementVendors + ProductCatalog absorbed into
// ProductSearch (tabs). ProcurementSettings owns the canonical Switchboard
// procurement controls; former Procurement settings and distributor routes redirect.
export const ProcurementDashboard = lazy(() => import('@/capabilities/procurement/pages/Procurement'));

export const ProcurementOverview = lazy(() =>
  import('@/capabilities/procurement/pages/ProcurementOverview').then((m) => ({ default: m.ProcurementOverview }))
);

export const ProductSearch = lazy(() =>
  import('@/capabilities/procurement/pages/ProductSearch').then((m) => ({ default: m.ProductSearch }))
);

export const PurchaseOrdersPage = lazy(() =>
  import('@/capabilities/procurement/pages/PurchaseOrdersPage').then((m) => ({ default: m.PurchaseOrdersPage }))
);

export const PurchaseOrderDetailPage = lazy(() =>
  import('@/capabilities/procurement/pages/PurchaseOrderDetailPage').then((m) => ({
    default: m.PurchaseOrderDetailPage,
  }))
);

export const OrderTrackingPage = lazy(() =>
  import('@/capabilities/procurement/pages/OrderTrackingPage').then((m) => ({ default: m.OrderTrackingPage }))
);

export const ProcurementSettings = lazy(() =>
  import('@/capabilities/procurement/pages/ProcurementSettings').then((m) => ({ default: m.ProcurementSettings }))
);

export const HardwareProfiles = lazy(() =>
  import('@/capabilities/procurement/pages/HardwareProfiles').then((m) => ({ default: m.HardwareProfiles }))
);

export const ProcurementBundles = lazy(() =>
  import('@/capabilities/procurement/pages/ProcurementBundles').then((m) => ({ default: m.ProcurementBundles }))
);

export const MicrosoftLicenses = lazy(() =>
  import('@/capabilities/procurement/pages/MicrosoftLicenses').then((m) => ({ default: m.MicrosoftLicenses }))
);

export const ProcurementPage = lazy(() =>
  import('@/capabilities/procurement/pages/ProcurementPage').then((m) => ({ default: m.ProcurementPage }))
);
